/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckoutSessionDto } from '../../models/checkout-session-dto';
import { CreateCheckoutSessionDto } from '../../models/create-checkout-session-dto';

export interface BillingControllerCreateCheckoutSession$Params {
      body: CreateCheckoutSessionDto
}

export function billingControllerCreateCheckoutSession(http: HttpClient, rootUrl: string, params: BillingControllerCreateCheckoutSession$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckoutSessionDto>> {
  const rb = new RequestBuilder(rootUrl, billingControllerCreateCheckoutSession.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CheckoutSessionDto>;
    })
  );
}

billingControllerCreateCheckoutSession.PATH = '/billing/create-checkout-session';
